import "./Home.css";
import PageHero from "../../components/PageHero/PageHero";
import HeroBlock from "../../components/Blocks/HeroBlock/HeroBlock";
import AboutBlock from "../../components/Blocks/AboutBlock/AboutBlock";
import StatsBlock from "../../components/Blocks/StatsBlock/StatsBlock";
import CompetenciesBlock from "../../components/Blocks/CompetenciesBlock/CompetenciesBlock";

function Home({ content, loading }) {
  if (loading || !content) {
    return <div className="home-page">Loading...</div>;
  }

  return (
    <div className="home-page">

      <PageHero
        title={content.pageHero?.home?.title}
        media={content.pageHero?.home?.media}
      />

      <AboutBlock
        smallTitle={content.block2?.smallTitle}
        mainTitle={content.block2?.mainTitle}
        description={content.block2?.description}
        image={content.block2?.image}
      />

      <StatsBlock
        icon={content.block5?.icon}
        value={content.block5?.value}
        label={content.block5?.label}
        description={content.block5?.description}
      />

      <CompetenciesBlock
        title={content.block4?.title}
        subtitle={content.block4?.subtitle}
        competencies={content.block4?.competencies}
      />

      <HeroBlock
        heading={content.block1?.heading}
        buttonText={content.block1?.buttonText}
        image={content.block1?.image}
      />

    </div>
  );
}

export default Home;
